import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import { notify } from 'react-notify-toast';
import { Row, Col, Table } from 'react-bootstrap';
import Pagination from "react-js-pagination";
import Roles from '../../../utils/Roles';
import swal from 'sweetalert';

class List extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'SAVE',
			isRedirect: false,
			showLoader: false,
			showListModal: false,
			currentPage: 1,
			todosPerPage: 10,
			activePage: 1,
			IntList: []
		}
	}

	componentDidMount() {
		this.loadInterview();
	}

	loadInterview() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('interview/getInterviewSetUp/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ IntList: res['data'].data });
				if (this.props.afterFinish) this.props.afterFinish();
				this.setState({ showLoader: false });
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.setState({ showLoader: false });
			}
		});
	}

	removeValue(id, e) {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('interview/removeInterview/' + this.state.masterId + '/' + this.state.companyId + '/' + id + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.loadInterview();
				notify.show(res['data'].msg, 'success');
			}
			else {
				notify.show(res['data'].msg, 'error');
				this.loadInterview();
				this.setState({ showLoader: false });
			}
		});
	}

	handleRemoveClick(id, e) {

		swal({ title: 'Confirm', text: 'Do you want to Delete?', buttons: ['No', 'Yes'] }).then((willYes) => {
			if (willYes) this.removeValue(id, e);
		});

	}


	render() {

		const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
		const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
		const currentTodos = this.state.IntList.slice(indexOfFirstTodo, indexOfLastTodo);
		let sno = indexOfFirstTodo + 1;

		return (
			<div>
				<Row>
					<Col md={12} >
						<Table hover responsive className="list-table">
							<thead>
								<tr>
									<th width="60" >Sl.No</th>
									<th>Course Category</th>
									<th>From Date</th>
									<th>To Date</th>
									<th>Time</th>
									<th>Manage</th>
								</tr>
							</thead>
							<tbody>
								{Object.keys(currentTodos).length > 0 ?
									currentTodos.map((item, key) => {
										return <tr key={key} >
											<td>{sno++}</td>
											<td style={{ textTransform: 'capitalize' }}>{item.categoryname}</td>
											<td>{item.fromdate}</td>
											<td>{item.todate}</td>
											<td align="center" >{item.intime}</td>
											<td>
												{Roles.Can('appointment', 'interview', 'candelete') ?
													<button className="btn btn-sm btn-danger btn-lowpadding" onClick={this.handleRemoveClick.bind(this, item.id)} >
														<i className="fa fa-remove"></i>
													</button> : null}
											</td>
										</tr>;
									})
									: <tr>
										<td colSpan="10" align="center" style={{ fontSize: '18px', color: 'brown' }}>
											No data found..!
										</td>
									</tr>
								}
							</tbody>
						</Table>
					</Col>
				</Row>
				<Row>
					<Col md={1} >
						<select className="form-control input-sm" onChange={(e) => { this.setState({ activePage: 1, currentPage: Number(1), todosPerPage: e.target.value }) }} >
							<option value="10"> 10 </option>
							<option value="15"> 15 </option>
							<option value="20"> 20 </option>
							<option value="50"> 50 </option>
							<option value="100"> 100 </option>
						</select>
					</Col>
					<Col md={10} >
						<Pagination
							activePage={this.state.activePage}
							itemsCountPerPage={this.state.todosPerPage}
							totalItemsCount={(this.state.IntList).length}
							pageRangeDisplayed={7}
							onChange={(pN) => { this.setState({ activePage: pN, currentPage: Number(pN) }) }}
						/>
					</Col>
				</Row>
			</div>
		);
	}

}
export default List;